//
//
//
//
//
//
//
//

export default {
  name: 'CoverImage',
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coverImageUrl() {
      if (_.get(this.artist, 'banners')) {
        const banner = this.artist.banners.filter(x => x.type === 'cover' && x.image.url);
        if (banner.length > 0) return banner[0].image.url;
      }
      return false;
    },
  },
};
